export { default } from "./AzureADTenantProvider";
